import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle } from "lucide-react";
import { Wordmark } from "@/components/Header";
import { site } from "@/config/site";
import { openWhatsApp, telUrl, trackPhoneClick } from "@/lib/whatsapp";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-[#0d261a] text-slate-300">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4 lg:px-8">
        <div className="md:col-span-1">
          <Wordmark light />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
            Accounting, tax, bookkeeping and business support for South African
            professionals, entrepreneurs and growing businesses.
          </p>
          <p className="mt-4 text-xs font-semibold uppercase tracking-[0.15em] text-[#C68B59]">
            {site.credentials.trustLine}
          </p>
        </div>

        <div>
          <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-white">Explore</h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/services" className="hover:text-white">Services</Link></li>
            <li><Link to="/who-we-help" className="hover:text-white">Who We Help</Link></li>
            <li><Link to="/about" className="hover:text-white">About Evan</Link></li>
            <li><Link to="/resources" className="hover:text-white">Resources</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-white">Get Started</h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/assessment" className="hover:text-white" data-testid="footer-assessment-link">Request a Consultation</Link></li>
            <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/admin/login" className="text-slate-500 hover:text-white">Team Login</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-white">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <a href={telUrl()} onClick={trackPhoneClick} data-testid="footer-phone-link" className="flex items-center gap-2 hover:text-white">
                <Phone className="h-4 w-4 text-[#C68B59]" /> {site.phoneDisplay}
              </a>
            </li>
            <li>
              <button onClick={() => openWhatsApp("general")} data-testid="footer-whatsapp-link" className="flex items-center gap-2 hover:text-white">
                <MessageCircle className="h-4 w-4 text-[#25D366]" /> WhatsApp Us
              </button>
            </li>
            <li>
              <a href={`mailto:${site.email}`} data-testid="footer-email-link" className="flex items-center gap-2 hover:text-white">
                <Mail className="h-4 w-4 text-[#C68B59]" /> {site.email}
              </a>
            </li>
            <li className="text-slate-400">{site.businessHours}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-slate-500 sm:flex-row sm:px-6 lg:px-8">
          <p>© {new Date().getFullYear()} Bonsai Financial. All rights reserved.</p>
          <p>Company Reg: {site.companyRegistration} · Led by {site.founderName}, {site.credentials.designation}.</p>
        </div>
      </div>
    </footer>
  );
}
